import React from 'react'

import { CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf, string } from 'prop-types'

import { iconSize, MODE } from 'Pods/LazyLoaded/AuthModal/constants'
import i18n from 'Pods/Shared/I18n'

function SuccessStep({ mode, email, locale = 'en' }) {
  const isLogin = mode === MODE.LOGIN
  const t = key => i18n.t(`auth_modal.success.${key}`, { ns: 'rails', lng: locale })

  return (
    <div className="auth-modal__success">
      <span className="auth-modal__success-icon">
        <Icon svgComponent={CircleCheck} size={iconSize} notSpaced />
      </span>
      <div className="auth-modal__header-group auth-modal__header-group--center">
        <p className="auth-modal__title cgt-heading-300">
          {isLogin ? t('login_title') : t('signup_title')}
        </p>
        <p className="auth-modal__subtitle cgt-body-md">
          {isLogin ? (
            <>
              {/* Prefix/suffix carry their own spacing so locales where the
                  email sits mid-sentence (ja) stay grammatical. */}
              {t('signed_in_prefix')}
              <span className="auth-modal__email cgt-body-md-semibold">{email.trim()}</span>
              {t('signed_in_suffix')}
            </>
          ) : (
            t('signup_subtitle')
          )}
        </p>
      </div>
    </div>
  )
}

SuccessStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
  email: string.isRequired,
  locale: string,
}

export default SuccessStep
